<template>
  <div
    v-if="infoElements.length"
    class="text-body-3 text-textLight d-flex flex-wrap ga-1"
  >
    {{ infoElements }}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatJobLevel } from '@/helpers/jobLevelDisplay';

const props = defineProps({
  profile: { type: Object, default: null },
});

const infoElements = computed(() => {
  const p = props.profile || {};
  return [
    p.job_code || p.hris_job_code,
    p.location,
    p.department,
    formatJobLevel(p.job_level, { mode: 'long' }),
    p.is_public ? 'Public' : null,
    p.is_flsa_exempt ? 'FLSA Exempt' : null,
  ]
    .filter(Boolean)
    .join(' · ');
});
</script>
